import app_config from '../config/app/config'

export const getReverseViewType = (currentView: string | undefined) => {
  const viewType = app_config.viewType
  return currentView === viewType.table ? 'wallView' : 'tableView'
}
